export default class MentionsManager {

    static getMentions(options:any) {
        const { task, projectId, companyId } = options
        let res:any = []

        const companyUsers = gd.session.companyUsers.filterByCompany(companyId)
        companyUsers.map((cu:any)=>{
            const { user } = cu
            if (user) {
                res.push({
                    id      : user.id,
                    name    : user.name,
                    userId  : user.id,
                    type    : 'user',
                    data    : user
                })
            }
        })

        const pId = projectId ? projectId : task ? task.projectId : null;
        const projectUsers = pId ? gd.session.projectUsers.filterByProject(pId) : [];
        projectUsers.map((pu:any)=>{
            const { user } = pu;
            if (pu.access >= gd.const.project.access.STANDARD) {
                res.push({
                    id: user.id,
                    name: user.name,
                    userId: user.id,
                    type: 'user',
                    data: user
                });
            }
        });

        const taskUsers = task ? _.map(task.users, u=>u.userId) : [];
        taskUsers.map(userId=>{
            const user = gd.session.users.get(userId)!
            res.push({
                id: user.id,
                name: user.name,
                userId: user.id,
                type: 'user',
                data: user
            });
        });
        res = _.uniqBy(res, (r:any)=>r.userId);

        return res;
    }
}

// module.exports = MentionsManager;